import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { useEffect } from "react";
import { useToast } from "@shared-kernel/primary/shared/shadcn/ui/use-toast";
import type { AppState } from "@redux/app-state";
import { useNavigate } from "react-router-dom";
import { resetUpdatePassword } from "../../../write/application/use-cases/password-update/update-password-reducer";

const selectPasswordUpdate = (state: AppState) => state.shared.updatePassword;

export const usePasswordUpdate = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { toast } = useToast();
  const { processing } = useAppSelector(selectPasswordUpdate);

  useEffect(() => {
    if (processing === "success") {
      navigate(`/login`);
      toast({ description: "Mot de passe mis à jour !" });
      // Reset state to prevent toast from showing again on re-mount
      dispatch(resetUpdatePassword());
    } else if (processing === "failed") {
      toast({ description: "Erreur lors de la mise à jour du mot de passe. Veuillez contacter l'administrateur", variant: "destructive" });
      // Reset state to prevent toast from showing again on re-mount
      dispatch(resetUpdatePassword());
    }
  }, [processing, dispatch, navigate, toast]);
};
